import { render, staticRenderFns } from "./StudentAmount.vue?vue&type=template&id=f0abd9a8&"
import script from "./StudentAmount.vue?vue&type=script&lang=js&"
export * from "./StudentAmount.vue?vue&type=script&lang=js&"
import style0 from "./StudentAmount.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports